import { z } from '../utils/zod.js';
import { dataResponse } from '../utils/response-templates.js';
import { planCodeSchema, planIntervalSchema } from '../pricing-catalogue.js';
import { meterAllowancesSchema, meterUsageSchema, subscriptionOverviewSchema } from '../subscriptions.js';
import { invoiceDtoSchema } from '../invoices.js';
import { adminSigningCompactSchema, adminSigningStateSchema, adminUserCompactSchema } from './compact.js';
import { adminPageResponse, adminPageSchema, adminPaginationQuerySchema } from './pagination.js';
export const adminOrganizationIdParamsSchema = z.object({
    organizationId: z.string().uuid(),
});
export const adminEntitlementsSchema = z.object({
    planCode: planCodeSchema,
    planInterval: planIntervalSchema.nullable(),
    isExempt: z.boolean(),
    maxUsers: z.number().int().nullable().openapi({ description: 'null = unlimited' }),
    allowances: meterAllowancesSchema.nullable().openapi({ description: 'null = unlimited, nothing is billed' }),
    canOverage: z.boolean(),
});
export const adminOrganizationDtoSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string().datetime(),
    name: z.string(),
    country: z.string(),
    taxId: z.string().nullable(),
    language: z.string(),
    customerType: z.enum(['BUSINESS', 'CONSUMER']),
    planCode: planCodeSchema,
    planInterval: planIntervalSchema.nullable(),
    pendingPlanInterval: planIntervalSchema.nullable(),
    billingExempt: z.boolean(),
    billingAnchorAt: z.string().datetime(),
    cancelAt: z.string().datetime().nullable(),
    planOverrides: z.unknown().nullable(),
    stripeCustomerId: z.string().nullable(),
    stripeSubscriptionId: z.string().nullable(),
    stripeSubscriptionStatus: z.string().nullable(),
    stripeScheduleId: z.string().nullable(),
    mcpAccessUntil: z.string().datetime().nullable(),
    mcpBlockedAt: z.string().datetime().nullable(),
    mcpBlockReason: z.string().nullable(),
    withdrawalConsentAt: z.string().datetime().nullable(),
    contractEndsAt: z
        .string()
        .datetime()
        .nullable()
        .openapi({ description: 'Enterprise contract end; informational, nothing acts on it' }),
    owner: adminUserCompactSchema,
    membersCount: z.number().int(),
    entitlements: adminEntitlementsSchema,
    usage: z.array(meterUsageSchema),
    subscription: subscriptionOverviewSchema,
});
export const adminOrganizationResponseSchema = dataResponse(adminOrganizationDtoSchema);
export const adminListMembersResponseSchema = adminPageResponse(adminUserCompactSchema);
export const adminOrganizationSigningSchema = adminSigningCompactSchema.extend({
    signersCount: z.number().int(),
    createdBy: adminUserCompactSchema,
});
export const adminListOrganizationSigningsQuerySchema = adminPaginationQuerySchema.extend({
    state: adminSigningStateSchema.optional(),
});
export const adminListOrganizationSigningsResponseSchema = adminPageResponse(adminOrganizationSigningSchema);
// The PDF link is left out: the admin panel never hands out downloads.
export const adminInvoiceDtoSchema = invoiceDtoSchema.omit({ invoicePdf: true });
export const adminListInvoicesResponseSchema = dataResponse(adminPageSchema(adminInvoiceDtoSchema).extend({
    upcoming: adminInvoiceDtoSchema.nullable(),
}));
